<div [ngStyle]="mapDivStyle()">
<div class='lgr_col'>
  <div class='lgr_10 col_01'><dynamic-field [id]='"scrndt"' [size]=10 [line]=1 [column]=1 [(ngModel)]='scrndt'></dynamic-field></div>
  <div class='lgr_40 col_20'><span class='brt high default' id='text1'>NATIONAL RAILROAD  PASSENGER CORPORATION</span>  </div>
  <div class='lgr_05 col_75'><span class='default' id='text2'>S140G</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_08 col_01'><dynamic-field [id]='"scrntm"' [size]=8 [line]=2 [column]=1 [(ngModel)]='scrntm'></dynamic-field></div>
  <div class='lgr_38 col_21'><span class='brt high default' id='text3'>ZONE TABLE FLS01T01 MAINTENANCE SCREEN</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_40 col_20'><span class='brt high default' id='text4'>----------------------------------------</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_55 col_01'><span class='brt high default' id='text5'>ENTER REQUIRED FIELDS AND HIT APPROPRIATE FUNCTION KEY:</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_55 col_01'><span class='brt high default' id='text6'>-------------------------------------------------------</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_09 col_01'><span class='default' id='text7'>ZONE ID: </span>  </div>
  <div class='lgr_04 col_18'><dynamic-field [id]='"zoneid"' [size]=4 [line]=8 [column]=18 [(ngModel)]='zoneid'></dynamic-field></div>
  <div class='lgr_00 col_23'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_11 col_01'><span class='default' id='text9'>ZONE DESC: </span>  </div>
  <div class='lgr_60 col_18'><dynamic-field [id]='"zndesc"' [size]=60 [line]=10 [column]=18 [(ngModel)]='zndesc'></dynamic-field></div>
  <div class='lgr_00 col_79'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_14 col_01'><span class='default' id='text11'>FROM-LOCN-CD: </span>  </div>
  <div class='lgr_03 col_18'><dynamic-field [id]='"frlocn"' [size]=3 [line]=12 [column]=18 [(ngModel)]='frlocn'></dynamic-field></div>
  <div class='lgr_00 col_22'>  </div>
  <div class='lgr_12 col_35'><span class='default' id='text13'>TO-LOCN-CD: </span>  </div>
  <div class='lgr_03 col_50'><dynamic-field [id]='"tolocn"' [size]=3 [line]=12 [column]=50 [(ngModel)]='tolocn'></dynamic-field></div>
  <div class='lgr_00 col_54'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_10 col_01'><span class='default' id='text15'>SBU CODE: </span>  </div>
  <div class='lgr_04 col_18'><dynamic-field [id]='"sbucd"' [size]=4 [line]=14 [column]=18 [(ngModel)]='sbucd'></dynamic-field></div>
  <div class='lgr_00 col_23'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"msgln"' [size]=79 [line]=22 [column]=1 [(ngModel)]='msgln'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_08 col_01'><span class='default' id='text17'>PF3=EXIT</span>  </div>
  <div class='lgr_10 col_12'><span class='default' id='text18'>PF4=RETURN</span>  </div>
  <div class='lgr_12 col_25'><span class='default' id='text19'>ENTER=SELECT</span>  </div>
  <div class='lgr_07 col_40'><span class='default' id='text20'>PF5=ADD</span>  </div>
  <div class='lgr_10 col_50'><dynamic-field [id]='"updtkey"' [size]=10 [line]=24 [column]=50 [(ngModel)]='updtkey'></dynamic-field></div>
</div>
</div>
